module.exports = __webpack_public_path__ + "img/mob4.19325d16.png";